/**
 * Function that generates new comments array, altering the comment with the target ID using the supplied update function.
 * @param {Array.<Object>} commentArray The exisiting comment list to search (won't be mutated).
 * @param {number} commentId The ID of the comment to updated..
 * @returns {Array.<Object>} a new (non-mutated) version of the comments array with the relevant comment updated using the updatedFunction.
 */
export const updateCommentById = (
  comments,
  commentId,
  updateFunction,
  ...params
) => {
  return comments.map((item) => {
    if (item.id === commentId) {
      return updateFunction(item, ...params);
    }
    return { ...item };
  });
};

/**
 * Function that generates new comments array, altering the comment with the target ID using the supplied update function.
 * The target comment should be a reply, as the functions attempts to locate the target ID by searching the children of the root comment passed.
 * @param {Array.<Object>} commentArray The exisiting comment list to search (won't be mutated).
 * @param {number} rootId The ID of the root level comment for the target child comment.
 * @param {number} commentId The ID of the comment to updated.
 * @returns {Array.<Object>} a new (non-mutated) version of the comments array with the relevant comment updated using the updatedFunction.
 */
export const updateChildCommentById = (
  comments,
  rootId,
  commentId,
  updateFunction,
  ...params
) => {
  return comments.map((item) => {
    if (item.id === rootId) {
      return {
        ...item,
        children: updateCommentById(
          item.children,
          commentId,
          updateFunction,
          ...params
        )
      };
    }
    return { ...item };
  });
};

/**
 * Updates the childLoading object for a comment on request.
 * @param {Array.<Object>} comment Comment object
 */
export const updateLoadMoreChildrenCommentsRequest = (comment) => {
  return {
    ...comment,
    childLoading: {
      ...comment.childLoading,
      isLoadingMore: true,
      loadMoreError: false
    }
  };
};
